import type { DonationReceipt } from '@/types/donationReceipt'

export type ReceiptFileKind = 'image' | 'pdf' | 'other'

const IMAGE_EXT = /\.(png|jpe?g|gif|webp|heic)$/i
const PDF_EXT = /\.pdf$/i

/** Infer attachment type from filename for icon and preview behaviour. */
export function receiptFileKind(filename: string): ReceiptFileKind {
  const name = filename.trim().toLowerCase()
  if (IMAGE_EXT.test(name)) return 'image'
  if (PDF_EXT.test(name)) return 'pdf'
  return 'other'
}

export function isReceiptImage(receipt: DonationReceipt): boolean {
  return receiptFileKind(receipt.filename) === 'image'
}

/** Trigger a browser download for a receipt attachment. */
export function downloadReceipt(receipt: DonationReceipt): void {
  const link = document.createElement('a')
  link.href = receipt.url
  link.download = receipt.filename
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/** Open a receipt for viewing (in-app preview for images, new tab otherwise). */
export function openReceiptForView(
  receipt: DonationReceipt,
  onImagePreview: (receipt: DonationReceipt) => void
): void {
  if (isReceiptImage(receipt)) {
    onImagePreview(receipt)
    return
  }
  window.open(receipt.url, '_blank', 'noopener,noreferrer')
}
